export let GenerateServiceDescriptionResponseType = /*#__PURE__*/function (GenerateServiceDescriptionResponseType) {
  GenerateServiceDescriptionResponseType["Start"] = "start";
  GenerateServiceDescriptionResponseType["Clarification"] = "clarification";
  GenerateServiceDescriptionResponseType["Message"] = "message";
  return GenerateServiceDescriptionResponseType;
}({});
export let GenerateServiceDescriptionType = /*#__PURE__*/function (GenerateServiceDescriptionType) {
  GenerateServiceDescriptionType["Title"] = "title";
  GenerateServiceDescriptionType["Description"] = "description";
  GenerateServiceDescriptionType["Message"] = "message";
  GenerateServiceDescriptionType["Preset"] = "preset";
  return GenerateServiceDescriptionType;
}({});